<template>
  <div class="c-search-engine">
    <div class="c-search-engine-row">
      <h2>Rodzaj paliwa</h2>
      <div class="c-search-engine-fuel">
        <!-- <div>
          <img src="../assets/images/engine.png" alt="">
        </div> -->
        <div class="c-search-engine-fuel-options">
          <select v-model="fuelSelectedKey">
            <option value="">Wybierz</option>
            <option v-for="(option,key) in Fueltype" v-bind:value="key" >{{option.name}}</option>
          </select>
          <!-- <div v-for="(option,key) in Fueltype" v-on:click="SelectFueltype (key)">
            <span class="checkbox" v-bind:class="{ active: option.selected == true }">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <polyline points="0 6.247 4.32 10.49 12.46 0.214" transform="translate(6 6)" fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="1"/>
              </svg>
            </span>
            <span>
              {{option.name}}
            </span>
          </div> -->
        </div>
      </div>
    </div>
    <!-- <div class="c-search-engine-row">
      <div class="c-search-engine-row-options">
        <div class="c-search-engine-gear-options">
          <h2>Skrzynia biegów</h2>
            <div v-for="(option,key) in Geartype" v-on:click="SelectGeartype (key)">
              <span class="checkbox" v-bind:class="{ active: option.selected == true }">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <polyline points="0 6.247 4.32 10.49 12.46 0.214" transform="translate(6 6)" fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="1"/>
                </svg>
              </span>
              <span>
                {{option.name}}
              </span>
            </div>
        </div>
        <div class="c-search-engine-gear-options">
          <h2>Napęd</h2>
          <div v-for="(option,key) in Transmissiontype" v-on:click="SelectTransmissiontype (key)">
            <span class="checkbox" v-bind:class="{ active: option.selected == true }">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <polyline points="0 6.247 4.32 10.49 12.46 0.214" transform="translate(6 6)" fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="1"/>
              </svg>
            </span>
            <span>
              {{option.name}}
            </span>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'SearchEngine',
  props: {
    Fueltype: {},
    Geartype:{},
    Transmissiontype: {}
  },
  data: function(){
    return {
      fuelSelectedKey: ''
    }
  },
  methods: {
    SelectFueltype (){

      for(var key in this.Fueltype){
        this.Fueltype[key].selected = false
      }
      this.Fueltype[this.fuelSelectedKey].selected = true;

      this.$emit('Fueltype', this.Fueltype)
    },
    SelectGeartype (key){
      if (this.Geartype[key].selected == true) {
        this.Geartype[key].selected = false
      }else{
        this.Geartype[key].selected = true
      }
      this.$emit('Geartype', this.Geartype)
    },
    SelectTransmissiontype (key){
      if (this.Transmissiontype[key].selected == true) {
        this.Transmissiontype[key].selected = false
      }else{
        this.Transmissiontype[key].selected = true
      }
      this.$emit('Transmissiontype', this.Transmissiontype)
    }
  },
  watch: {
    fuelSelectedKey: {
      handler: function(){
        this.SelectFueltype();
      }
    }
  }
}
</script>

<style lang="scss">
  .c-search-engine{
    // margin: 0 auto;
    // max-width: 1177.6px;
    // width: 92%;
    // padding:2rem 0 0 0;
    // @media(min-width: 960px){
    //   padding-right: 2rem;
    // }
    &-row{
      // border-bottom: 1px solid #b3b3b3;
      // padding: 0 0 2rem 0;
      // margin-bottom: 2rem;
      &-options{
        display: flex;
        justify-content: flex-start;
        @media(max-width: 960px){
          display: block;
        }
      }
    }
    &-fuel{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media(max-width: 960px){
        display: block;
      }
      &-options{
        div{
          margin-bottom: 1rem;
          margin-left: 2rem;
          @media(max-width: 960px){
            margin-left: 0;

          }
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 1.1rem;
          color:#4c4c4c;
          .checkbox{
            margin-right: 1rem;
          }
        }
      }
    }
    &-gear{

      &-options{
        margin-right: 3rem;
        div{
          margin-bottom: 15px;
          margin-right: 1rem;
          .checkbox{
            margin-right: 1rem;
          }
        }
      }
    }
    select{
      -webkit-appearance:none;
      border: 1px solid #000;
      padding: .5rem 1rem;
      border-radius: 0;
      background-color: #fff;
      min-width: 180px;
      @media(max-width:374px){
      min-width:150px;
      margin:0 auto;
      }
    }
    h2{
    @media(max-width:500px){
    font-size:17px;
    }
    }
  }
</style>
